import React from 'react';
import { Link } from 'react-router-dom';

const logo = `${process.env.PUBLIC_URL}/logo-original.png`;

function LandingPage() {
  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <div className="logo">
              <Link to="/" aria-label="Zivug Mishamayim home">
                <img src={logo} alt="Zivug Mishamayim" className="logo-image" />
              </Link>
            </div>
            <div className="nav-links">
              <a href="#features">Features</a>
              <a href="#how-it-works">How It Works</a>
              <Link to="/donate">Donate</Link>
              <a href="https://app.zivugmishamayim.com/" className="cta-button-nav" target="_blank" rel="noopener noreferrer">Get Started</a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Finding Your <span className="highlight">Bashert</span>
                <br />
                Made Meaningful
              </h1>
              <p className="hero-subtitle">
                A modern matchmaking platform designed exclusively for the Jewish community. 
                Connect with singles through trusted matchmakers, with complete privacy control 
                and organized communication throughout your shidduch journey.
              </p>
              <div className="hero-buttons">
                <a href="#cta" className="cta-button-primary">Download Now</a>
                <a href="#features" className="cta-button-secondary">Learn More</a>
              </div>
            </div>
            <div className="hero-image">
              <div className="phone-mockup">
                <div className="phone-notch"></div>
                <div className="phone-screen">
                  <div className="app-preview">
                    {/* App Header */}
                    <div className="app-top-bar">
                      <div className="status-bar">
                        <span className="time">19:10</span>
                        <div className="status-icons">
                          <span className="wifi-icon">📶</span>
                          <span className="battery-icon">🔋</span>
                        </div>
                      </div>
                    </div>

                    {/* Discover Header */}
                    <div className="discover-header">
                      <h2 className="discover-title">Discover</h2>
                      <button className="success-stories-btn">
                        🎉 Success Stories
                      </button>
                      <div className="notification-bell">🔔</div>
                    </div>

                    {/* Search Bar with Filter */}
                    <div className="search-filter-bar">
                      <div className="search-input">
                        <span className="search-icon">🔍</span>
                        <span className="search-text">Search profiles...</span>
                      </div>
                      <button className="filter-btn">
                        <div className="filter-icon">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </button>
                    </div>

                    {/* Profile Grid */}
                    <div className="profile-grid">
                      {/* Profile Card 1 - No Photo */}
                      <div className="grid-profile-card">
                        <div className="age-badge">32 y/o</div>
                        <div className="profile-image no-photo">
                          <div className="placeholder-icon">👤</div>
                        </div>
                        <div className="profile-name">Sarah Cohen</div>
                      </div>

                      {/* Profile Card 2 - With Photo */}
                      <div className="grid-profile-card">
                        <div className="age-badge">28 y/o</div>
                        <div className="profile-image with-photo">
                          <div className="photo-gradient gradient-blue"></div>
                        </div>
                        <div className="profile-name">David Levi</div>
                      </div>

                      {/* Profile Card 3 - With Photo */}
                      <div className="grid-profile-card">
                        <div className="age-badge">24 y/o</div>
                        <div className="profile-image with-photo">
                          <div className="photo-gradient gradient-purple"></div>
                        </div>
                        <div className="profile-name">Rachel Gold</div>
                      </div>

                      {/* Profile Card 4 - Private/Locked */}
                      <div className="grid-profile-card">
                        <div className="age-badge">31 y/o</div>
                        <div className="profile-image locked">
                          <div className="lock-overlay">
                            <span className="lock-icon">🔒</span>
                          </div>
                        </div>
                        <div className="profile-name">Private User</div>
                      </div>

                      {/* Profile Card 5 - No Photo */}
                      <div className="grid-profile-card">
                        <div className="age-badge">29 y/o</div>
                        <div className="profile-image no-photo">
                          <div className="placeholder-icon">👤</div>
                        </div>
                        <div className="profile-name">Moshe Stein</div>
                      </div>

                      {/* Profile Card 6 - With Photo */}
                      <div className="grid-profile-card">
                        <div className="age-badge">26 y/o</div>
                        <div className="profile-image with-photo">
                          <div className="photo-gradient gradient-green"></div>
                        </div>
                        <div className="profile-name">Leah Miller</div>
                      </div>
                    </div>

                    {/* Bottom Navigation */}
                    <div className="bottom-nav">
                      <div className="nav-item active">
                        <div className="nav-icon home-icon">🏠</div>
                        <span className="nav-label">Home</span>
                      </div>
                      <div className="nav-item">
                        <div className="nav-icon">💙</div>
                        <span className="nav-label">Connect</span>
                      </div>
                      <div className="nav-item">
                        <div className="nav-icon">💰</div>
                        <span className="nav-label">Donations</span>
                      </div>
                      <div className="nav-item">
                        <div className="nav-icon">👤</div>
                        <span className="nav-label">Profile</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="phone-button"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Everything You Need for a Successful Shidduch</h2>
            <p className="section-subtitle">
              Powerful features designed to make the matchmaking process smooth, private, and effective
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">👤</div>
              <h3>Comprehensive Profiles</h3>
              <p>Detailed profiles with photos, religious background, education, and family details. Control every aspect of your privacy.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Advanced Privacy Controls</h3>
              <p>Field-level privacy settings, "Ask Me" feature for sensitive information, and multiple photo privacy options.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔍</div>
              <h3>Smart Search & Filters</h3>
              <p>Advanced filtering by age, location, religious observance, education, and more. Gender-specific filters for relevant criteria.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💑</div>
              <h3>Matchmaker Network</h3>
              <p>Connect through trusted matchmakers who facilitate introductions and guide the process with care and discretion.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>Real-time Communication</h3>
              <p>Instant notifications for match responses, info requests, and updates. In-app messaging keeps everything organized.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💍</div>
              <h3>Engagement Celebrations</h3>
              <p>Beautiful engagement announcements with confetti and celebrations. Track successful matches and share simchas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">How It Works</h2>
            <p className="section-subtitle">
              A simple, thoughtful process designed for meaningful connections
            </p>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Create Your Profile</h3>
              <p>Build a comprehensive profile with your personal information, photos, and preferences. Set privacy controls on any field.</p>
            </div>
            <div className="step-connector"></div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Browse & Search</h3>
              <p>Use advanced filters to find potential matches. Matchmakers can suggest profiles and request additional information.</p>
            </div>
            <div className="step-connector"></div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Express Interest</h3>
              <p>When both parties show interest, choose to continue directly or with a matchmaker as intermediary.</p>
            </div>
            <div className="step-connector"></div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Connect & Celebrate</h3>
              <p>Build your relationship with privacy and support. When you're engaged, share the simcha with the community!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Privacy Section */}
      <section className="privacy-section">
        <div className="container">
          <div className="privacy-content">
            <div className="privacy-text">
              <h2>Your Privacy is Our Priority</h2>
              <p>
                We understand the sensitive nature of the shidduch process. That's why Zivug Mishamayim 
                gives you complete control over your information:
              </p>
              <ul className="privacy-list">
                <li>
                  <span className="check-icon">✓</span>
                  Field-level privacy controls for every piece of information
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Multiple photo privacy options: Open, One-time view, Private, or No photo
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  "Ask Me" feature for sensitive details you'd rather share personally
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Secure authentication and role-based access controls
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Profile approval system ensures quality and authenticity
                </li>
              </ul>
            </div>
            <div className="privacy-image">
              <div className="privacy-shield">
                <div className="shield-icon">🔐</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section
      <section className="testimonials">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Success Stories</h2>
            <p className="section-subtitle">
              Real couples who found their bashert through Zivug Mishamayim
            </p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                The privacy controls gave me confidence to create a detailed profile. I found my husband 
                within three months, and we couldn't be happier!
              </p>
              <div className="testimonial-author">
                <strong>Sarah & David</strong>
                <span>Married June 2025</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                As a matchmaker, this app makes my work so much easier. I can track all my suggestions 
                and communicate efficiently with both sides.
              </p>
              <div className="testimonial-author">
                <strong>Mrs. Cohen</strong>
                <span>Professional Matchmaker</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                The organized approach and advanced filters helped me find exactly what I was looking for. 
                We're engaged and planning our wedding!
              </p>
              <div className="testimonial-author">
                <strong>Rachel & Moshe</strong>
                <span>Engaged January 2026</span>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section id="cta" className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Find Your Bashert?</h2>
            <p>
              Join thousands of singles and matchmakers in the Jewish community 
              who are making meaningful connections through Zivug Mishamayim
            </p>
            <div className="cta-buttons">
              <button className="cta-button-primary large" disabled style={{ opacity: 0.6, cursor: 'not-allowed' }}>
                <span>App Store - Coming Soon</span>
              </button>
              <a 
                href="https://play.google.com/store/apps/details?id=com.zivugmishamayim&pli=1"
                className="cta-button-primary large"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', display: 'inline-block' }}
              >
                <span>Get it on Google Play</span>
              </a>
            </div>
            <p className="cta-note">Available for iOS and Android</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <Link to="/" aria-label="Zivug Mishamayim home">
                <img src={logo} alt="Zivug Mishamayim" className="footer-logo" />
              </Link>
              <p>Making meaningful matches in the Jewish community</p>
            </div>
            <div className="footer-section">
              <h4>Product</h4>
              <ul>
                <li><a href="#features">Features</a></li>
                <li><a href="#how-it-works">How It Works</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                <li><Link to="/donate">Donate</Link></li>
                <li><Link to="/support">Help &amp; Support</Link></li>
                <li><a href="mailto:support@zivugmishamayim.com">Email Us</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/privacy">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 Zivug Mishamayim. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
